import { React, connect, Redirect, withRouter } from '@gasbuddy/react';
import { Unauthorized } from './Unauthorized';
import { hasAnyGroup } from '../../../client/lib/auth';

const AuthComponent = ({
  children,
  account_id: aid,
  groups = [],
  forRoles,
  forActions,
  location,
  unauthorized = null,
  hideUnauthorized = false,
}: {
    children: React.Element,
    unauthorized: ?React.Element,
    account_id: ?string,
    groups: ?Array<Array<string>>,
    forRoles: string | Array<string>,
    forActions: Array<string>,
    location: Object,
    hideUnauthorized: boolean,
  }) => {
  // eslint-disable-next-line camelcase
  if (!aid) {
    return (
      <Redirect
        to={{
          pathname: '/auth/login',
          search: `returnUrl=${encodeURIComponent(location.pathname + location.search)}`,
        }}
      />
    );
  }

  if (forRoles) {
    const checkRoles = Array.isArray(forRoles) ? forRoles : forRoles.split(',');
    if (!hasAnyGroup(groups, ...checkRoles)) {
      if (hideUnauthorized) {
        return null;
      }
      if (unauthorized) {
        return unauthorized;
      }
      return (
        <Unauthorized />
      );
    }
  }

  if (forActions) {
    let checkRoles = forActions;
    if (Array.isArray(forActions[0])) {
      // This is an array of actions, which themselves are arrays of roles, so flatten it out
      checkRoles = [].concat(...forActions).filter(a => !!a);
    }
    if (!hasAnyGroup(groups, ...checkRoles)) {
      if (hideUnauthorized) {
        return null;
      }
      if (unauthorized) {
        return unauthorized;
      }
      return (
        <Unauthorized />
      );
    }
  }

  return children;
};

export const Auth = withRouter(
  connect(({ auth }) => ({ groups: auth.groups, account_id: auth.account_id }))(AuthComponent),
);
